import CloseIcon from '@mui/icons-material/Close'
import { useMediaQuery } from '@mui/material'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { format as dateFnsFormat } from 'date-fns'
import { ru } from 'date-fns/locale'
import { useState } from 'react'
import { StorageBuyDialog } from '../../../../dialogs/StorageBuyDialog'
import { StorageCancelDialog } from '../../../../dialogs/StorageCancelDialog'
import { StorageChangeDialog } from '../../../../dialogs/StorageChangeDialog'
import { useProfileStore } from '../../../../store/storeProfile'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { theme } from '../../../../theme'

const Wrapper = ({ isMobile, className, children }) => {
    if (isMobile) {
        return (
            <div
                style={{
                    minWidth: '100%',
                }}
                className={className}>
                {children}
            </div>
        )
    } else {
        return (
            <Grid
                size={{ xs: 12, sm: 12, lg: 6 }}
                sx={{ width: '100%' }}
                spacing={0}
                className={className}>
                {children}
            </Grid>
        )
    }
}

export const StorageCard = ({ item, active, isHasPeriod }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { title, id, price_coins, name, storage_gb } = item
    const { fetchStorage } = useWrapperStore((state) => state)
    const {
        userTariff,
        createStorageTariffUser,
        removeStorageTariffUser,
        fetchStorageTariffUser,
        fetchBillingListSpent,
    } = useProfileStore((state) => state)
    const [isOpenStorageBuyDialog, setIsOpenStorageBuyDialog] = useState(false)
    const [isOpenStorageChangeDialog, setIsOpenStorageChangeDialog] = useState(false)
    const [isOpenStorageCancelDialog, setIsOpenStorageCancelDialog] = useState(false)

    const handleCloseStorageBuyDialog = () => {
        setIsOpenStorageBuyDialog(false)
    }

    const handleCloseStorageCancelDialog = () => {
        setIsOpenStorageCancelDialog(false)
    }

    const handleStorageBuy = () => {
        setIsOpenStorageBuyDialog(true)
    }
    const handleStorageChange = () => {
        setIsOpenStorageChangeDialog(true)
    }

    const handleCloseStorageChangeDialog = () => {
        setIsOpenStorageChangeDialog(false)
    }

    const handleSubmitStorageBuyDialog = async () => {
        await createStorageTariffUser({ tariff_id: id, auto_renew: true })
        await fetchStorageTariffUser()
        await fetchBillingListSpent()
        await fetchStorage()
        handleCloseStorageBuyDialog()
        handleCloseStorageChangeDialog()
    }

    const handleSubmitStorageCancelDialog = async () => {
        await removeStorageTariffUser({ id: active.id })
        await fetchStorageTariffUser()
        await fetchStorage()
        handleCloseStorageCancelDialog()
    }

    return (
        <Wrapper isMobile={isMobile}>
            <Stack
                spacing={0}
                direction="column"
                justifyContent="space-between"
                sx={{
                    background: isMobile ? '#F5F5F5' : 'none',
                    width: '100%',
                    textAlign: 'left',
                    p: isMobile ? 2 : 3,
                    borderTop: '1px solid #E9EAED',
                    borderBottom: '1px solid #E9EAED',
                    borderRight: '1px solid #E9EAED',
                    position: 'relative',
                    overflow: 'hidden',
                    height: '100%',
                    borderRadius: isMobile ? '12px' : 0,
                    '&:hover': {
                        borderRadius: isMobile ? '12px' : 0,
                    },
                }}>
                <Stack direction="column">
                    <Stack
                        direction="row"
                        sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography gutterBottom variant="body1" component="div">
                            {name}
                        </Typography>

                        {active?.is_active && <Typography variant="body2">Текущий</Typography>}
                    </Stack>
                    <Typography
                        variant="h2"
                        sx={{ fontSize: '40px', fontWeight: 600, color: '#000' }}>
                        {storage_gb} ГБ диск{' '}
                    </Typography>
                </Stack>
                {!active && !isHasPeriod && (
                    <Button
                        sx={{ p: '10px 24px', mb: '12px', mt: 3 }}
                        color="primary"
                        variant="contained"
                        fullWidth
                        onClick={handleStorageBuy}>
                        {`Подключить за ${price_coins} коинов`}
                    </Button>
                )}
                {!active && isHasPeriod && (
                    <Button
                        sx={{ p: '10px 24px', mb: '12px', mt: 3 }}
                        color="primary"
                        variant="contained"
                        fullWidth
                        onClick={handleStorageChange}>
                        {`Сменить за ${price_coins} коинов`}
                    </Button>
                )}

                {active && (
                    <Stack
                        direction={isMobile ? 'column' : 'row'}
                        sx={{
                            justifyContent: 'space-between',
                            alignItems: isMobile ? 'left' : 'center',
                            background: '#F6F6F6',
                            borderRadius: '8px',
                            px: isMobile ? 0 : 2,
                            mb: '12px',
                            mt: 3,
                        }}>
                        <Typography variant="body2" sx={{ color: '#5A5C5E', p: '10px 0' }}>
                            Активен {active?.is_active ? 'до' : 'c'}{' '}
                            {dateFnsFormat(
                                active?.is_active ? active.end_at : active.start_at,
                                'd MMMM yyyy',
                                {
                                    locale: ru,
                                },
                            )}
                        </Typography>
                        {active.auto_renew && (
                            <Button
                                startIcon={<CloseIcon />}
                                sx={{
                                    justifyContent: 'flex-start',
                                    p: isMobile ? '0' : '10px 24px',
                                    gap: 0,
                                    '& .MuiButton-startIcon': {
                                        marginRight: '4px',
                                    },
                                }}
                                color="primary"
                                variant="text"
                                onClick={() => setIsOpenStorageCancelDialog(true)}>
                                Отменить подписку
                            </Button>
                        )}
                    </Stack>
                )}
            </Stack>
            {isOpenStorageBuyDialog && (
                <StorageBuyDialog
                    storage={item}
                    open={isOpenStorageBuyDialog}
                    handleClose={handleCloseStorageBuyDialog}
                    handleSubmit={handleSubmitStorageBuyDialog}
                />
            )}

            {isOpenStorageChangeDialog && (
                <StorageChangeDialog
                    storage={item}
                    open={isOpenStorageChangeDialog}
                    handleClose={handleCloseStorageChangeDialog}
                    handleSubmit={handleSubmitStorageBuyDialog}
                />
            )}

            {isOpenStorageCancelDialog && active && (
                <StorageCancelDialog
                    storage={active}
                    open={isOpenStorageCancelDialog}
                    handleClose={handleCloseStorageCancelDialog}
                    handleSubmit={handleSubmitStorageCancelDialog}
                />
            )}
        </Wrapper>
    )
}
